<template>
    <WarehouseInventory></WarehouseInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const WarehouseInventory = defineAsyncComponent(() =>
    import("../../components/Logistics/WarehouseInventory.vue")
);
export default {
    name: "Logistics_WarehouseInventory", //The name you are in should not equal the name of the component you are importing.
    components: { WarehouseInventory, AuthLayout },
};
</script>
